// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__86vuJ","colMaxWidth":"Table_colMaxWidth__2eN13"};